import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import Loading from 'custom/assets/loaders/Loading'
import TermsConditionService from '../../services/terms-and-conditions.service'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import { useHistory } from 'react-router-dom'
import { SIDENAV_KEYS } from '../../utils/translation-constants'

function TermsAndConditions() {
  const [stage, setStage] = useState(0)
  const [dataSource, setDataSource] = useState({})
  const { t } = useTranslation()
  const history = useHistory()

  const fetchTermsAndConditions = useCallback(async (data) => {
    try {
      setStage(0)
      const response = await TermsConditionService.getTermsAndConditions({ module: 'GENERAL' })
      if (response.status === 200) {
        if (response.data['termsAndCondition']) {
          setDataSource(response.data['termsAndCondition'][0])
          setStage(1)
        }
      }
    } catch (err) {
      setStage(1)
    }
  }, [])

  useEffect(() => {
    fetchTermsAndConditions()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderTermsConditions()
      default:
        return renderLoading()
    }
  }

  function renderTermsConditions() {
    return (
      <div className=''>
        <h4 className='heading-style' style={{ textAlign: 'center', fontSize: 25 }}>
          {t(SIDENAV_KEYS.TERMS_AND_CONDITIONS_KEYS.TITLE)}
        </h4>
        <div>
          <p
            dangerouslySetInnerHTML={{ __html: dataSource?.message || '' }}
            className='text-justify'
            style={{ height: 300, overflow: 'overlay', whiteSpace: 'pre-line' }}></p>
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='d-flex flex-column text-center'>
        <div className='my-4'>
          <Loading width='50px' height='50px' />
        </div>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='TERMS_AND_CONDITIONS' keyPath={'TERMS_AND_CONDITIONS'}>
      <div className=''>{renderSwitch()}</div>
    </LayoutWithOutAccountCard>
  )
}

export default TermsAndConditions
